export enum enumServiceStatus {
  Inactive,
  Active,
  'Original Active',
  'Manually Processed'
}

export namespace enumServiceStatus {
  export function values() {
    return Object.keys(enumServiceStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
